import React, { useEffect, useState } from "react";
import {
  Modal,
  Select,
  Checkbox,
  Image,
  Form,
  DatePicker,
  Button,
  Input,
  Radio,
  Space,
} from "antd";
import moment from "moment";
import { breakPlainOptionsreason, breakPlainOptionsTime } from "../../../../utils/Helpers";
import altimg from "../../../../assets/images/placeholder/placeimg100.png";
import * as breakActions from "../../../../redux/actions/break.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Option } = Select;
const BreakModal = (props) => {
  const [filter, setFilter] = useState("");
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const setFiltervalue = (value) => {
    setFilter(value);
  };

  const [value, setValue] = useState("break");
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const disabledDate = (current) => {
    return current && current < moment();
  };

  useEffect(() => {
    if (props.RiderId) {
      form.setFieldsValue(props.RiderId);
    }
  }, [props.RiderId]);
  const [form] = Form.useForm();

  const statusSubmit = async (values) => {
    const dataTid = {
      ...values,
      riderId: props.RiderId.riderId,
      type: "break",
      is_forced_break: values.is_forced_break === true?1:0,
    };
    try {
      setMBtnLoading(true);
      await props.breakActions.breakMarkAction(dataTid);
    } catch (e) {} finally {
      setMBtnLoading(false);
      props.handleCancel()
    }
  };

  return (
    <Modal
      title="Put on break"
      visible={props.assignBreakModal}
      onCancel={props.handleCancel}
      footer={[
        <Button loading={MBtnLoading} key="back" onClick={props.handleCancel}>
          Cancel
        </Button>,
        <Button loading={MBtnLoading} form="myForm" key="submit" htmlType="submit">
          Submit
        </Button>,
      ]}
      style={{
        top: 20,
      }}
    >
      <Space style={{marginBottom:"20px"}}>
        {props.RiderImage ? (
          <Image alt="Profile Image" src={props.RiderImage} width="50px" height= "50px" />
        ) : (
          <img alt="Profile Image" src={altimg} width="50px" height= "50px" />
        )}
        {props.RiderName}
        {props.RiderDisplayId}-{props.RiderTookanId}
      </Space>
      <Form
        form={form}
        id="myForm"
        layout="vertical"
        // onFinish={props.onFinish}
        onFinish={statusSubmit}
      >
        <Form.Item name={"riderId"} label="Username" hidden={true}>
          <Input type="text" />
        </Form.Item>
        {/* <Form.Item name={"type"}>
          <Radio.Group onChange={onChange} value={value} defaultValue={value}>
            <Radio value="break">Break</Radio>
            <Radio value="tmp">TMP</Radio>
          </Radio.Group>
        </Form.Item> */}
        <Form.Item
          name={"duration"}
          label="Duration"
          rules={[{ required: true, message: "Duration is Required" }]}
        >
          <Select
            placeholder="Duration"
            style={{ width: "100%" }}
            value={filter}
            onChange={setFiltervalue}
          >
            {breakPlainOptionsTime && breakPlainOptionsTime.map((item) => (
              <Option value={item.value}>{item.label}</Option>
            ))}
          </Select>
        </Form.Item>
        {filter == "customize" ? (
          <Form.Item
            name={"startDate"}
            label="Start Date"
            rules={[
              {
                required: true,
                message: "Please add start date time",
              },
            ]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm:ss"
              disabledDate={disabledDate}
              showTime={{
                defaultValue: moment("00:00:00", "HH:mm:ss"),
              }}
            />
          </Form.Item>
        ) : (
          ""
        )}
        {filter == "customize" ? (
          <Form.Item
            name={"endDate"}
            label="End Date"
            rules={[
              {
                required: true,
                message: "Please add end date time",
              },
            ]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm:ss"
              disabledDate={disabledDate}
              showTime={{
                defaultValue: moment("00:00:00", "HH:mm:ss"),
              }}
            />
          </Form.Item>
        ) : (
          ""
        )}
        <Form.Item
          name={"reason"}
          label="Reason"
          rules={[{ required: true, message: "Reason is Required" }]}
        >
          <Select placeholder="Reason" style={{ width: "100%" }}>
            {breakPlainOptionsreason && breakPlainOptionsreason.map((item) => (
              <Option value={item.value}>{item.label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name={"is_forced_break"} valuePropName="checked">
          <Checkbox>Forced Break</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};


const mapStateToProps = (state) => {
  return {
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    breakActions: bindActionCreators(breakActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BreakModal);
// export default BreakModal;
